import { useContext } from 'react';

import { RovingIndexContext } from '../../contexts';

export const useRovingIndex = () => useContext(RovingIndexContext);
